import {classNames} from "@progress/kendo-react-common"
import {
    Calendar,
    CalendarCellProps,
    CalendarProps,
    DatePicker,
    DatePickerChangeEvent,
} from "@progress/kendo-react-dateinputs"
import {FieldRenderProps} from "@progress/kendo-react-form"
import dayjs from "dayjs"
import React, {createContext} from "react"
import {useAppSelector} from "../../store"
import {RootState} from "../../rootReducer"
import {Tooltip} from "@progress/kendo-react-tooltip"

const EffectiveDateContext = createContext({
    testDate: new Date(),
    updateEffectiveDatePickerValue: (date: Date) => {},
})

const CustomEffectiveCell = (props: CalendarCellProps) => {
    const dateView = props.view === 0
    const selectedPackageDetails = useAppSelector((state: RootState) => state.containers.fees.testPackageDetails)
    const {updateEffectiveDatePickerValue} = React.useContext(EffectiveDateContext)
    const noScheduleTitle = "Only future dates can be selected when editing a package"
    var result =
        dayjs(selectedPackageDetails.effectiveDate).format("DD/MM/YYYY") === dayjs(props.value).format("DD/MM/YYYY") &&
        dayjs(selectedPackageDetails.effectiveDate).format("DD/MM/YYYY") === dayjs(new Date()).format("DD/MM/YYYY") &&
        selectedPackageDetails.testPackageID !== 0
    var result2 = dayjs(props.value).startOf("day") > dayjs(new Date()).startOf("day")

    var result3 =
        dayjs(selectedPackageDetails.effectiveDate).format("DD/MM/YYYY") === dayjs(new Date()).format("DD/MM/YYYY") &&
        (selectedPackageDetails.testPackageID === 0 || selectedPackageDetails.testPackageID === undefined)

    let effectiveIndex = result ? -1 : result2 ? (result3 ? -1 : 1) : -1

    const hasScheduleForDay = effectiveIndex >= 0

    const handleClick = (ev: any) => {
        if (hasScheduleForDay && dateView) {
            if (props.onClick) {
                props.onClick(props.value)
                updateEffectiveDatePickerValue(props.value)
            }
        }
    }

    const style = {
        cursor: !hasScheduleForDay && dateView ? "not-allowed" : "pointer",
        opacity: !hasScheduleForDay && dateView ? 0.6 : 1,
    }

    const className = classNames({
        "k-calendar-td": true,
        "k-selected": props.isSelected,
        "k-today": props.isToday,
        "k-focus": props.isFocused,
    })

    const titleValue: string = !hasScheduleForDay && dateView ? noScheduleTitle : ""
    return (
        <td onClick={handleClick} className={className}>
            <span className="k-link" style={style} title={titleValue}>
                {props.children}
            </span>
        </td>
    )
}

const CustomEffectiveCalendar = (props: CalendarProps) => {
    const {min, value, focusedDate} = props
    const {updateEffectiveDatePickerValue} = React.useContext(EffectiveDateContext)
    const onchangeCalendar = (ev: any) => {
        updateEffectiveDatePickerValue(ev.value)
    }

    return (
        <Tooltip anchorElement="target" position="top">
            <Calendar
                onChange={onchangeCalendar}
                bottomView="month"
                topView="month"
                cell={CustomEffectiveCell}
                value={value}
                min={min}
                focusedDate={focusedDate}
            />
        </Tooltip>
    )
}
export const TestPackageEffectiveDatePicker = (fieldRenderProps: FieldRenderProps) => {
    const {name, label, value, min, disabled, updateStateValue} = fieldRenderProps
    const [showDatePicker, setShowDatePicker] = React.useState<boolean>(false)
    const [testDate] = React.useState<Date>(dayjs(value).toDate())

    const updateEffectiveDatePickerValue = (testDate: Date) => {
        updateStateValue(testDate)
        setShowDatePicker(false)
    }

    const onDateChange = (event: DatePickerChangeEvent) => {
        if (dayjs(event.target.value).startOf("day") >= dayjs().startOf("day")) {
            if (event.nativeEvent.target.tagName === "INPUT") {
                return false
            }
        }
    }

    const onDateBlur = (event: any) => {
        setShowDatePicker(false)
    }

    const dateProviderProps = {testDate, updateEffectiveDatePickerValue}
    return (
        <EffectiveDateContext.Provider value={dateProviderProps}>
            <DatePicker
                name={name}
                label={label}
                min={min}
                disabled={disabled}
                show={showDatePicker}
                value={testDate}
                onFocus={() => {
                    setShowDatePicker(true)
                }}
                onBlur={onDateBlur}
                onChange={onDateChange}
                calendar={CustomEffectiveCalendar}
                focusedDate={testDate}
            />
        </EffectiveDateContext.Provider>
    )
}
